import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("td", {
    ref: "value",
    style: _normalizeStyle(`left: ${$options.formattedOffset}`),
    class: _normalizeClass(['gfu-product-comparison-table-value', $options.themeClass, $options.textClass])
  }, [
    ($options.hasValue)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString($props.value), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock(_component_base_icon, {
          key: 1,
          name: $props.value,
          size: "xs"
        }, null, 8 /* PROPS */, ["name"]))
  ], 6 /* CLASS, STYLE */))
}